const automations = {
  table: {
    header: {
      suppliers: 'Fleets',
    },
    filters: {
      suppliers: {
        title: 'Fleets',
      },
    },
  },
  wizard: {
    information: {
      supplier: 'Fleets',
    },
  },
};

export default automations;
